module.exports = __webpack_public_path__ + "static/media/BE.3ea20255.png";